import React from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { countHierarchyEntities, formatHierarchyEntitiesCounts } from "../../../Helper/DigitalTwin/DigitalTwinFunctions";
import { PrimaryTooltip } from "../../../Components/StyledComponent";
import CustomIcon from "../../../Components/CustomIcon";
import { normalizeKey } from "../../../Helper/Common/common_helpers";
import { useBatterySystem } from "../../../Pages/DigitalTwinV3/DigitalTwinContext";

const BatterySidebarContainer = ({ title = 'Battery System', tab, children }) => {
    const { t } = useTranslation(['common', 'digital_twin'])
    const batterySystem = useBatterySystem();
    const hierarchyEntitiesCount = countHierarchyEntities(batterySystem);
    const tooltipTitle = formatHierarchyEntitiesCounts(hierarchyEntitiesCount);

    return (
        <Box sx={{ px: 2, py: 2.5 }} display="flex" flexDirection="column">
            <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="fw500s14c2E2E2E">{t(`digital_twin:${normalizeKey(title)}`, title)}</Typography>
                {tab === 'batteryVitals' && (
                    <PrimaryTooltip title={tooltipTitle} placement="bottom">
                        <Box sx={{ lineHeight: 0 }}>
                            <CustomIcon name="circle-info-icon" width={16} height={16} sx={{
                                width: '16px',
                                height: '16px',
                                "&:hover": {
                                    "& path": {
                                        stroke: "#6D72F6 !important"
                                    }
                                }
                            }} />
                        </Box>
                    </PrimaryTooltip>
                )}
            </Stack>

            <Divider sx={{ mt: 2, mb: 2.5, px: 2 }} />

            {children}
        </Box>
    );
};

export default BatterySidebarContainer;
